import { NgModule } from '@angular/core';
import { AngularPhoneticComponent } from './angular-phonetic.component';

@NgModule({
  declarations: [AngularPhoneticComponent],
  imports: [
  ],
  exports: [AngularPhoneticComponent]
})
export class AngularPhoneticModule { }
